import { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Testimonial {
  quote: string;
  name: string;
  role: 'mentor' | 'mentee';
  detail: string;
}

const testimonials: Testimonial[] = [
  {
    quote: "I never would've had the success I had without Project SHORT to guide me along so now I'm giving back and meeting incredible future colleagues from all across the country with the wildest stories and the biggest of dreams :)",
    name: "Natalia Batchenkova",
    role: "mentor",
    detail: "MD/PhD student, University of Nebraska Medical Center and the NIH Rocky Mountain Labs and Pre-health Mentor since 2021",
  },
  {
    quote: "It's nice to connect with the next generation of doctors. I love meeting students from minority backgrounds who are ready to represent and advocate for marginalized communities with their passion in healthcare.",
    name: "Derek Tean",
    role: "mentor",
    detail: "Medical Student, Western University of Health Sciences, Pomona Campus and Pre-health Mentor since 2024",
  },
  {
    quote: "Project SHORT allows me to continue sharing my love for mentorship with students whom I wouldn't usually be able to reach. My mentors have strongly shaped my journey to medical school and continue to do so. Giving back to the pre-med community through Project SHORT gives me a lot of fulfilment and motivation to keep giving back as I move through my career!",
    name: "Anonymous",
    role: "mentor",
    detail: "Pre-health Mentor since 2025",
  },
  {
    quote: "I've seen firsthand how transformative strong mentorship can be. Guiding applicants through the MD/PhD process, especially those who may not have access to pre-health/pre-grad advising, aligns deeply with my values and experiences. I want to continue helping students find clarity, confidence, and community during a stressful part of their journey.",
    name: "Megan Arnold",
    role: "mentor",
    detail: "MD/PhD student, University of Pittsburgh and Pre-health Mentor since 2022",
  },
  {
    quote: "I was a mentee with Project SHORT, and the guidance I received was instrumental to my success. As an international student who applied directly from my undergraduate program during the challenges of the COVID-19 pandemic, I honestly believe I would not have successfully navigated the application cycle without the crucial support Project SHORT provided. I am highly motivated to help current applicants guide through their own cycles. I am passionate about providing the necessary support for international students, as readily available and accessible information for this group is often scarce. I wish to be a supportive resource, just as my Project SHORT mentor was for me five years ago.",
    name: "Anonymous",
    role: "mentor",
    detail: "Pre-health Mentor",
  },
  {
    quote: "As someone who has navigated competitive academic spaces without insider knowledge or much representation, I deeply understand the value of mentorship. I want to be able to play that role for others!",
    name: "Yasmin Landa",
    role: "mentor",
    detail: "PhD student, UC Berkeley, a former mentee and Pre-Grad Mentor since 2025",
  },
  {
    quote: "This is my 4th year as pre-grad mentor and I could not be more proud to be part of Project SHORT! As former International student, I am aware on how challenging it can be to apply for graduate school in the US: I have been in that situation in the past and I was lucky to have the support of my colleagues (I was already working in the US as lab tech). Unfortunately, most international applicants do not have this kind of support and this is why I decided to join Project SHORT!",
    name: "Maria Luisa Valle",
    role: "mentor",
    detail: "Postdoctoral fellow, New York University and Pre-Grad Mentor since 2022",
  },
  {
    quote: "I want to be a mentor with Project SHORT because I wouldn't be where I am without people who took the time to guide me, answer questions I was scared to ask, and show me that I belonged in science. Those \"hand up\" moments made a huge difference in my path, and I'd love to do the same for someone else. I especially care about helping students who feel unsure about navigating research or the grad school process—because I've been there, and I know how confusing it can be without someone in your corner. Mentoring is one of the most meaningful parts of being in science for me, and Project SHORT feels like the right place to pay forward the support that shaped my trajectory.",
    name: "Meredith Jones",
    role: "mentor",
    detail: "PhD student, Indiana University School of Medicine, Pre-Grad mentor",
  },
  {
    quote: "Mentorship has played a huge role in my own journey, and I'm ready to pay that forward. The guidance I've received over the years helped shape my path, and now I want to support others with the knowledge and insight I've gained as they navigate the admissions process. I also greatly appreciate Project SHORT's mission to make high-quality mentorship accessible to everyone. I'd love to be part of a community that uplifts, empowers, and celebrates future scholars.",
    name: "Jasmine Moon",
    role: "mentor",
    detail: "PhD student, Washington University in St. Louis, Pre-Grad Mentor since 2025",
  },
  {
    quote: "The process for applying to clinical psychology PhD programs can be confusing and disheartening. I'm hoping to lift the veil on some of the barriers that may prevent students with lesser resources from sending in strong applications. There is a critical need in clinical psychology for diverse voices. I applied many cycles for PhD programs and have a strong sense of where the gaps in my application were from year to year, always trying to strengthen my application for the next cycle. I hope I can pass the lessons I learned to younger researchers trying to get their foot in the door.",
    name: "Yulan Chen",
    role: "mentor",
    detail: "Clinical Science PhD student, Vanderbilt University, Pre-Grad Mentor since 2025",
  },
  {
    quote: "Project SHORT, especially my direct mentorship from Dr. Leah Bakst, were pivotal in my success throughout the graduate school application process. Leah closely advised me in crafting a polished application: I'm deeply grateful for her detailed edits of my CV and her reviews of my scientific writing. Most impactful of all, Leah empowered me to find my own voice in my essays. With her guidance, I found the language to proudly characterize my research in an application that best represented me.",
    name: "Chloe Retika",
    role: "mentee",
    detail: "PhD student, University of California, Los Angeles and Pre-Grad Mentee",
  },
  {
    quote: "Graham was an amazing mentor. He showed care throughout the process, and even as I was thinking about the various offers I had. The feedback he gave my essays was specific and constructive. Upon reflection, I think that the mentorship really helped me as a student who was applying from an \"unconventional\" path — I didn't do the \"typical\" RA-ship in a lab before applying for grad school.",
    name: "Howard Chiu",
    role: "mentee",
    detail: "PhD student, Stanford University and Pre-Grad Mentee",
  },
  {
    quote: "I had a great time with Project SHORT and my mentor, Regina, who was available by email for several months of my graduate application process. I also appreciated contact with a wide variety of mentees through mock interviews, which helped me mentally prepare for the later stages of the process.",
    name: "Sean Lyon",
    role: "mentee",
    detail: "PhD student, University of Connecticut and Pre-Grad Mentee",
  },
  {
    quote: "My mentor is like sunshine. She gave me courage, support and encouragement. She helps me a lot. I truly appreciate all the help from her and Project SHORT!",
    name: "Siyuan Wang",
    role: "mentee",
    detail: "PhD student, McGill University and Pre-Grad Mentee",
  },
  {
    quote: "I felt that both the fee waiver and the support with my Project SHORT mentor helped me tremendously this past cycle. With the fee waiver, I was able to apply to quite a few extra programs I otherwise would have not been able to afford to apply to. With my mentor, I was able to feel more confident in the application documents I was submitting, both for the NSF GRFP and also my PhD applications! Together, these led to a successful cycle, by which I was able to interview with and get into four programs and received great comments on my GRFP. Super thankful for all the resources I was able to utilize through Project SHORT!",
    name: "Kaitlyn Huizar",
    role: "mentee",
    detail: "PhD Student, University of North Carolina, former Pre-Grad mentee and a current mentor",
  },
];

export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const changeSlide = useCallback((newIndex: number) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setIsTransitioning(false);
    }, 200);
  }, []);

  const goToNext = useCallback(() => {
    changeSlide((currentIndex + 1) % testimonials.length);
  }, [currentIndex, changeSlide]);

  const goToPrev = useCallback(() => {
    changeSlide((currentIndex - 1 + testimonials.length) % testimonials.length);
  }, [currentIndex, changeSlide]);

  const goToSlide = (index: number) => {
    if (index !== currentIndex) {
      changeSlide(index);
    }
  };

  // Auto-advance every 7 seconds
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(goToNext, 7000);
    return () => clearInterval(interval);
  }, [isPaused, goToNext]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') {
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [goToNext, goToPrev]);

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="mb-16">
          <h2 className="text-sm uppercase tracking-widest text-primary mb-4">
            Testimonials
          </h2>
          <p className="text-4xl md:text-5xl font-light text-gray-900">
            Stories from our community
          </p>
        </div>

        <div
          className="relative"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {/* Main testimonial card */}
          <div className="relative bg-white rounded-xl p-6 pt-8 pb-6 md:p-12 md:pl-20 md:pr-20 min-h-[350px] md:min-h-[420px] flex flex-col">
            {/* Quote text with fade transition */}
            <blockquote className={cn(
              "flex-1 overflow-y-auto md:flex md:items-center transition-opacity duration-200",
              isTransitioning ? "opacity-0" : "opacity-100"
            )}>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
                {currentTestimonial.quote}
              </p>
            </blockquote>

            {/* Author info */}
            <div className={cn(
              "flex items-center gap-3 md:gap-4 mt-4 md:mt-6 pt-4 md:pt-6 border-t border-gray-100 flex-shrink-0 transition-opacity duration-200",
              isTransitioning ? "opacity-0" : "opacity-100"
            )}>
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <span className="text-primary font-medium text-sm md:text-base">
                  {currentTestimonial.name === 'Anonymous'
                    ? '?'
                    : currentTestimonial.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-gray-900 text-sm md:text-base">{currentTestimonial.name}</p>
                <p className="text-xs md:text-sm text-gray-500 line-clamp-2">
                  {currentTestimonial.detail}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation arrows - hidden on mobile, shown on md+ */}
          <button
            onClick={goToPrev}
            className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gray-50 hover:bg-gray-100 items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={goToNext}
            className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gray-50 hover:bg-gray-100 items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          {/* Bottom navigation: arrows (mobile) + dots + counter */}
          <div className="flex items-center justify-center gap-4 md:gap-6 mt-6 md:mt-8">
            {/* Mobile arrows */}
            <button
              onClick={goToPrev}
              className="md:hidden w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500"
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>

            <div className="flex gap-1.5 md:gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={cn(
                    "w-1.5 h-1.5 md:w-2 md:h-2 rounded-full transition-all duration-300",
                    index === currentIndex
                      ? "bg-primary w-4 md:w-6"
                      : "bg-gray-300 hover:bg-gray-400"
                  )}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            {/* Mobile arrows */}
            <button
              onClick={goToNext}
              className="md:hidden w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500"
              aria-label="Next testimonial"
            >
              <ChevronRight className="w-4 h-4" />
            </button>

            <span className="hidden md:inline text-sm text-gray-400">
              {currentIndex + 1} of {testimonials.length}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
